<template>
  <div class="body">
    <div class="section wf-section"></div>
    <div class="section-2 last wf-section">
      <div class="container w-container">
        <div class="arbitrarily-placed-and-sized-parent-element">
          <div class="video-embed-object-fit-cover">
            <vue-flv-player type="flv" :autoplay="true" :controls="true" :muted="true" ref="myPlayer"
              source="http://74.62.195.106:8000/live/dubhome.flv" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VideoPlayer from '@/components/VideoPlayer'

export default {
  components: {
    // VideoPlayer
  },
  mounted() {
    console.log('mounted')
  }
}
</script>

<style>
/* 
  Arbitrarily sized & positioned element that will 
  contain the embedded video as background.
*/
.arbitrarily-placed-and-sized-parent-element {
  position: relative;
  top: 0px;
  left: 0px;

  width: 100vw;
  height: calc(100vh - 70px);
}

/*
  This element contains the iframe, will take it's size from
  it's parent and will behave like an image/video 
  with object-fit: cover.
*/
.video-embed-object-fit-cover {
  position: absolute;

  /* ensure positioning regardless of parent flex settings */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  width: 100%;
  height: 100%;

  /* important */
  container-type: size;

  /* cut off overflowing video */
  overflow: hidden;
}

.video-embed-object-fit-cover>iframe {
  position: absolute;
  /* keep video centered both vertically and horizontally */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 100%;
  height: 100%;

  /* force aspect ratio based on parent container */
  @container (min-aspect-ratio: 16/9) {
    height: 56.25cqw;
    /* 100*9/16 */
  }

  @container (max-aspect-ratio: 16/9) {
    width: 177.78cqh;
    /* 100*16/9 */
  }

  /* prevent interaction */
  /* pointer-events: none; */
}
</style>